import React, { useEffect, useState } from "react";
import { ProductContext } from "./index";
import { PostData } from "../services/FetchData";
import { startOfMonth } from "date-fns";

const ProductProvider = props => {
	const [userData, setUserData] = useState({}),
		[userLoader, setUserLoader] = useState(true),
		[websiteData, setWebsiteData] = useState({}),
		[userWebsitePlan, setUserWebsitePlan] = useState(null),
		[productTypes, setProductTypes] = useState([]),
		[currentWebsiteId, setCurrentWebsiteId] = useState(null),
		[websiteLoader, setWebsiteLoader] = useState(true),
		[addPageOpen, setAddPageOpen] = useState(false),
		[loadVisualEditor, setLoadVisualEditor] = useState(false),
		[products, setProducts] = useState([]),
		[categoryId, setCategoryId] = useState(null),
		[originalProductOrder, setOriginalProductOrder] = useState(new Map()),
		[categories, setCategories] = useState([]),
		[description, setDescription] = useState(""),
		[productLoader, setProductLoader] = useState(false),
		[productCount, setProductCount] = useState(null),
		[productPage, setProductPage] = useState(1),
		[pagePerProducts, setPagePerProducts] = useState(10),
		[enableSave, setEnableSave] = useState(false),
		[rowPerProducts, setRowPerProducts] = useState(4),
		[shopCurrency, setShopCurrency] = useState('USD'),
		[hasMore, setHasMore] = useState(false),
		[productOrder, setProductOrder] = useState(new Map()),
		[newProductOrder, setNewProductOrder] = useState(new Map()),
		[promoted, setPromoted] = useState([]),
		[buried, setBuried] = useState([]),
		[hidden, setHidden] = useState([]),
		[buriedProducts, setBuriedProducts] = useState([]),
		[hiddenProducts, setHiddenProducts] = useState([]),
		[saveLoader, setSaveLoader] = useState(false),
		[categoryIds, setCategoryIds] = useState([]),
		[pinnedItems, setPinnedItems] = useState({}),
		[originalProducts, setOriginalProducts] = useState([]),
		[hiddenProductIndex, setHiddenProductIndex] = useState({}),
		[activeItem, setActiveItem] = useState(null),
		[editCategoryMerchandising, setEditCategoryMerchandising] = useState(null),
		[searchPhrase, setSearchPhrase] = useState(""),
		[editSearchPhraseMerchandising, setEditSearchPhraseMerchandising] = useState(null),
		[editLandingPageMerchandising, setEditLandingPageMerchandising] = useState(null),
		[addedProductIds, setAddedProductIds] = useState([]),
		[addedProducts, setAddedProducts] = useState({}),
		[exact, setExact] = useState(true),
		[platForm, setPlatForm] = useState(""),
		[editorPageFlag, setEditorPageFlag] = useState(false),
		[pageLoader, setPageLoader] = useState(false),
		[activeMenu, setActiveMenu] = useState('general'),
		[pinnedProductIndex, setPinnedProductIndex] = useState({}),
		[magentoStoreViewsLoader, setMagentoStoreViewsLoader] = useState(true),
		[websitePlatform, setWebsitePlatform] = useState(""),
		[defaultStoreView, setDefaultStoreView] = useState(""),
		[magentoStoreViews, setMagentoStoreViews] = useState({}),
		[landingPageSearchPhrase, setLandingPageSearchPhrase] = useState(""),
		[landingPageId, setLandingPageId] = useState(null),
		[searchPhraseModal, setSearchPhraseModal] = useState(false),
		[loadOriginalProduct, setLoadOriginalProduct] = useState(false),
		[landingPageFilter, setLandingPageFilter] = useState([]),
		[banners, setBanners] = useState([]),
		[banner, setBanner] = useState(null),
		[selectedBanner, setSelectedBanner] = useState(null),
		[bannerLoader, setBannerLoader] = useState(false),
		[channels, setChannels] = useState([]),
		[channelsLoader, setChannelsLoader] = useState(true),
		[selectedBannerId, setSelectedBannerId] = useState(null),
		[channelId, setChannelId] = useState("1"),
		[debouncedSearch, setDebouncedSearch] = useState(""),
		[merchandisingError, setMerchandisingError] = useState(""),
		[promoTileLoader, setPromoTileLoader] = useState(false),
		[promoTiles, setPromoTiles] = useState([]),
		[selectedPromoTiles, setSelectedPromoTiles] = useState({}),
		[enableDynamic, setEnableDynamic] = useState(false),
		[dynamicItems, setDynamicItems] = useState({}),
		[newProducts, setNewProducts] = useState([]),
		[triggerDynamic, setTriggerDynamic] = useState(false),
		[dateRange, setDateRange] = useState({
			startDate: startOfMonth(new Date()),
			endDate: new Date(),
			key: "selection",
		}),
		// Filter-related state
		[filterValues, setFilterValues] = useState([]),
		[currentFilter, setCurrentFilter] = useState(null),
		// AI Visibility monitoring gate (from getMonitoringProject API)
		[monitoringEnabled, setMonitoringEnabled] = useState(false)

	useEffect(() => {
		if (websiteData && currentWebsiteId) {
			if (typeof websiteData[currentWebsiteId] !== "undefined" && websiteData[currentWebsiteId]) {
				setWebsitePlatform(websiteData[currentWebsiteId]?.websiteType || "")
				setUserWebsitePlan(websiteData[currentWebsiteId]?.websiteUserPlan || [])
				// Extract productTypes from productsMapping - ensure it's an array
				const productsMapping = Array.isArray(websiteData[currentWebsiteId]?.productsMapping)
					? websiteData[currentWebsiteId].productsMapping
					: []
				setProductTypes(productsMapping)
				if (websiteData[currentWebsiteId].websiteType === "magento") {
					// Use the getStoreViews endpoint
					PostData("ms2", "api/v1/magento/getStoreViews", { websiteId: currentWebsiteId }).then(result => {
						if (result !== "Invalid" && result !== "undefined") {
							if (result.status === "success") {
								// Handle new format (array of store views)
								if (result.data.storeViews && Array.isArray(result.data.storeViews)) {
									let storeViewObj = {};
									result.data.storeViews.forEach(sv => {
										if (sv.code) {
											storeViewObj[sv.code] = sv.name || sv.code;
										}
									});
									setMagentoStoreViews(storeViewObj);
									if (Object.keys(storeViewObj).length > 0) {
										setDefaultStoreView(Object.keys(storeViewObj)[0]);
									}
								} else if (result.data.storeViewObj) {
									// Handle old format (object) for backward compatibility
									let storeViewObj = result.data.storeViewObj;
									setMagentoStoreViews(storeViewObj);
									if (Object.keys(storeViewObj).length > 0) {
										setDefaultStoreView(Object.keys(storeViewObj)[0]);
									}
								}
								setMagentoStoreViewsLoader(false);
							}
						} else {
							setMagentoStoreViewsLoader(false);
						}
					}).catch(error => {
						console.error("Error fetching Magento store views:", error);
						setMagentoStoreViewsLoader(false);
					})
				} else if (websiteData[currentWebsiteId]?.websiteType === "bigcommerce" && Array.isArray(productsMapping) && productsMapping.indexOf("search") !== -1) {
					PostData("ms3", "api/v1/bigcommerce/getChannels", { websiteId: currentWebsiteId }).then(result => {
						if (result !== "Invalid" && result !== "undefined" && result) {
							if (result.status === "success" && result.data ) {
								setChannels(result.data.channels)
							}
							setChannelsLoader(false)
						} else {
							setChannelsLoader(false);
						}
					}).catch(error => {
						console.error("Error fetching BigCommerce channels:", error);
						setChannelsLoader(false);
					})
				} else {
					// WooCommerce, Shopify, Drupal, etc. do not use channels; allow list pages to load
					setChannelsLoader(false);
				}
			}
		}
	}, [currentWebsiteId, websiteData])

	// Filter-related functions
	const getFilteredValues = (filterId) => {
		if (!filterId) return filterValues
		return filterValues.filter(item => item.filterId === filterId)
	}


	const updateFilterValues = (newValues) => {
		setFilterValues(newValues);
	};

	const updateCurrentFilter = (newFilter) => {
		setCurrentFilter(newFilter);
	};

	const applySortingToValues = (values, sortType) => {
		if (!values || values.length === 0) return values;

		let sorted = [...values];

		switch (sortType) {
			case "nameAsc":
				sorted.sort((a, b) =>
					(a.displayName || a.value || a.value1 || "").localeCompare(
						b.displayName || b.value || b.value1 || "",
					),
				);
				break;
			case "nameDesc":
				sorted.sort((a, b) =>
					(b.displayName || b.value || b.value1 || "").localeCompare(
						a.displayName || a.value || a.value1 || "",
					),
				);
				break;
			case "manual":
				sorted.sort((a, b) => (a.pos || 0) - (b.pos || 0));
				break;
			default:
				// Default order
				break;
		}
		return sorted;
	};

	const store = {
		pageLoader,
		setPageLoader,
		editorPageFlag,
		setEditorPageFlag,
		activeMenu,
		setActiveMenu,
		userData,
		setUserData,
		userLoader,
		setUserLoader,
		websiteData,
		websiteLoader,
		setWebsiteLoader,
		originalProductOrder,
		setOriginalProductOrder,
		setWebsiteData,
		currentWebsiteId,
		setCurrentWebsiteId,
		originalProducts,
		setOriginalProducts,
		addPageOpen,
		setAddPageOpen,
		products,
		setProducts,
		description,
		setDescription,
		categoryId,
		setCategoryId,
		categories,
		setCategories,
		productLoader,
		setProductLoader,
		productPage,
		setProductPage,
		productCount,
		setProductCount,
		enableSave,
		setEnableSave,
		pagePerProducts,
		setPagePerProducts,
		rowPerProducts,
		setRowPerProducts,
		shopCurrency,
		setShopCurrency,
		hiddenProductIndex,
		setHiddenProductIndex,
		hasMore,
		setHasMore,
		productOrder,
		setProductOrder,
		promoted,
		setPromoted,
		buried,
		setBuried,
		hidden,
		setHidden,
		buriedProducts,
		setBuriedProducts,
		hiddenProducts,
		setHiddenProducts,
		saveLoader,
		setSaveLoader,
		categoryIds,
		setCategoryIds,
		activeItem,
		setActiveItem,
		editCategoryMerchandising,
		setEditCategoryMerchandising,
		loadVisualEditor,
		setLoadVisualEditor,
		pinnedItems,
		setPinnedItems,
		searchPhrase,
		setSearchPhrase,
		pinnedProductIndex,
		setPinnedProductIndex,
		editSearchPhraseMerchandising,
		setEditSearchPhraseMerchandising,
		exact,
		setExact,
		platForm,
		setPlatForm,
		magentoStoreViews,
		magentoStoreViewsLoader,
		websitePlatform,
		defaultStoreView,
		setDefaultStoreView,
		landingPageSearchPhrase,
		setLandingPageSearchPhrase,
		landingPageFilter,
		setLandingPageFilter,
		landingPageId,
		setLandingPageId,
		editLandingPageMerchandising,
		setEditLandingPageMerchandising,
		searchPhraseModal,
		setSearchPhraseModal,
		loadOriginalProduct,
		setLoadOriginalProduct,
		banners,
		setBanners,
		selectedBanner,
		banner,
		setBanner,
		setSelectedBanner,
		selectedBannerId,
		setSelectedBannerId,
		userWebsitePlan,
		setUserWebsitePlan,
		productTypes,
		setProductTypes,
		channels,
		setChannels,
		channelsLoader,
		setChannelsLoader,
		bannerLoader,
		setBannerLoader,
		promoTileLoader,
		setPromoTileLoader,
		promoTiles,
		setPromoTiles,
		selectedPromoTiles,
		setSelectedPromoTiles,
		channelId,
		setChannelId,
		debouncedSearch,
		setDebouncedSearch,
		merchandisingError,
		setMerchandisingError,
		enableDynamic,
		setEnableDynamic,
		dynamicItems,
		setDynamicItems,
		triggerDynamic,
		setTriggerDynamic,
		newProducts,
		setNewProducts,
		addedProductIds,
		setAddedProductIds,
		addedProducts,
		setAddedProducts,
		newProductOrder,
		setNewProductOrder,
		dateRange,
		setDateRange,
		// Filter-related properties
		filterValues,
		setFilterValues,
		currentFilter,
		setCurrentFilter,
		getFilteredValues,
		updateFilterValues,
		updateCurrentFilter,
		applySortingToValues,
		monitoringEnabled,
		setMonitoringEnabled,
	};
	return (
		<ProductContext.Provider value={store}>
			{props.children}
		</ProductContext.Provider>
	);
};

export default ProductProvider;
